import angular from 'angular';
import directive from './department-resources.directive';

export default angular.module('app.components.advisory.bcp.departmentResources', [])
  .directive('bcpDepartmentResources', directive)
  .controller('DepartmentResourcesController', () => { /* here to provide controllerAs vm */ })
  .name;

console.log('app.components.advisory.bcp.departmentResources created');
